import { useEffect, useState } from "react";
import apiClient from "./api/apiClient";

let registryCache = null;
let registryPromise = null;

async function loadRegistry() {
  if (registryCache) return registryCache;
  if (!registryPromise) {
    const fetchFallback = async () => {
      const base = apiClient?.defaults?.baseURL || "";
      const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
      const strippedBase = normalizedBase.replace(/\/api$/, "");
      const candidateUrls = [
        "/destructive-actions/registry",
        normalizedBase ? `${normalizedBase}/destructive-actions/registry` : null,
        normalizedBase && !normalizedBase.endsWith("/api") ? `${normalizedBase}/api/destructive-actions/registry` : null,
        strippedBase && strippedBase !== normalizedBase ? `${strippedBase}/destructive-actions/registry` : null,
      ].filter(Boolean);

      let lastError = null;
      for (const url of candidateUrls) {
        try {
          const res = await fetch(url, {
            credentials: "include",
          });
          if (!res.ok) {
            lastError = new Error(`Registry fetch failed: ${res.status}`);
            continue;
          }
          return await res.json();
        } catch (err) {
          lastError = err;
        }
      }
      throw lastError || new Error("Registry fetch failed");
    };

    registryPromise = apiClient
      .get("/destructive-actions/registry", { skipAuthRedirect: true })
      .then((res) => res.data)
      .catch(() => fetchFallback())
      .then((data) => {
        registryCache = data;
        return data;
      })
      .catch((err) => {
        registryPromise = null;
        throw err;
      });
  }
  return registryPromise;
}

export async function getDestructiveAction(actionId) {
  const registry = await loadRegistry();
  return (registry?.entries || []).find((entry) => entry.action_id === actionId) || null;
}

export function useDestructiveAction(actionId) {
  const [action, setAction] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    if (!actionId) return undefined;
    loadRegistry()
      .then((registry) => {
        if (!active) return;
        const found = (registry?.entries || []).find((entry) => entry.action_id === actionId) || null;
        setAction(found);
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
      });
    return () => {
      active = false;
    };
  }, [actionId]);

  return { action, error };
}
